module.exports = __webpack_public_path__ + "public/Icons/19Managepromocode.svg?c19551bb";